import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataEngagement } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function Engagement(props: IElementDataEngagement) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { engagement: engagementValue, settings } = props;
    const fieldKey: ElementMetadataFieldName = 'engagement';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || engagementValue == undefined) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel icon={{ type: 'mi', value: 'engagement' }}>
                {t(`element_data_label.${fieldKey}`)}
            </ElementDataRowLabel>
            <ElementDataRowValue>{engagementValue}</ElementDataRowValue>
        </ElementDataRow>
    );
}
